export default __webpack_public_path__ + "static/media/Nunito-Bold.c8d0ed25.ttf";